// iCraftz - Library (9-category intent framework)

export const bookExamples = [
  {
    id: 1,
    title: "Unleash the Power of Reading",
    author: "Manjunath M.S.",
    category: "Deep Focus",
    categories: ["Deep Focus", "Habits"],
    isbn: "9789391507879",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/w97otzf0_IMG_9304.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/w97otzf0_IMG_9304.jpg",
    summary: "Transform your mind and life through the power of strategic reading. Learn to read like a millionaire and achieve 10X growth by mastering speed reading, retention, and applying book knowledge to real life.",
    insights: ["Reading is not just a hobby, it's a high-ROI investment in yourself", "Speed reading without comprehension is useless - focus on retention techniques", "The gap between where you are and where you want to be can be bridged by the right books", "Successful people read to learn, not just to finish books"],
    actionItems: ["Commit to reading at least 30 minutes daily without distractions", "Create a reading list aligned with your goals for the next 90 days", "After each chapter, write down 3 key takeaways and one action step", "Join or form a book club to discuss and reinforce learning"],
    coreTheme: "Reading is the fastest shortcut to success - read like a millionaire, think like a millionaire, become a millionaire."
  },
  {
    id: 2,
    title: "The 10X Rule",
    author: "Grant Cardone",
    category: "Leadership",
    categories: ["Leadership", "Mindset"],
    isbn: "9780470627600",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9780470627600-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9780470627600-L.jpg",
    summary: "Success requires 10 times more effort than you think, and setting goals 10 times higher than what you believe you can achieve.",
    insights: ["Average thinking and actions lead to average results", "Success is your duty, obligation, and responsibility", "Fear and uncertainty are signals you're on the right path", "Commit first, figure out how later"],
    actionItems: ["Rewrite your top 3 goals with 10X bigger outcomes", "List 40 actions (not 4) you can take this week", "Eliminate one excuse you've been using", "Commit to one uncomfortable conversation today"],
    coreTheme: "Massive action is the cure-all to mediocrity and the path to extraordinary success."
  },
  {
    id: 3,
    title: "The ONE Thing",
    author: "Gary Keller",
    category: "Deep Focus",
    categories: ["Deep Focus", "Habits"],
    isbn: "9781885167774",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781885167774-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781885167774-L.jpg",
    summary: "Focus on the ONE thing that matters most, and let everything else fall into place or fall away. Extraordinary results come from narrowing your focus.",
    insights: ["Going small is ignoring all the things you could do and doing what you should do", "You can do two things at once, but you can't focus on two things at once", "Success leaves clues - look for the ONE thing successful people do", "Multitasking is a lie - focus is the path to mastery"],
    actionItems: ["Identify your ONE thing for this year, month, week, and today", "Block 4 hours tomorrow morning for your ONE thing", "Say NO to 3 things that don't align with your ONE thing", "Remove one distraction from your workspace"],
    coreTheme: "Ask: What's the ONE thing I can do that will make everything else easier or unnecessary?"
  },
  {
    id: 4,
    title: "Atomic Habits",
    author: "James Clear",
    category: "Habits",
    categories: ["Habits", "Vitality"],
    isbn: "9780735211292",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9780735211292-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9780735211292-L.jpg",
    summary: "Tiny changes lead to remarkable results. Focus on getting 1% better every day through small habit improvements.",
    insights: ["Your habits are perfectly designed to deliver your current results", "Every action is a vote for the type of person you wish to become", "The secret to results is to never stop making improvements", "Habits are the compound interest of self-improvement"],
    actionItems: ["Choose one tiny habit to start today", "Design your environment to make good habits obvious", "Create an implementation intention: 'I will [behavior] at [time] in [location]'", "Join a culture where your desired behavior is normal"],
    coreTheme: "You do not rise to the level of your goals, you fall to the level of your systems."
  },
  {
    id: 5,
    title: "Think and Grow Rich",
    author: "Napoleon Hill",
    category: "Wealth",
    categories: ["Wealth", "Mindset"],
    isbn: "9781585424337",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781585424337-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781585424337-L.jpg",
    summary: "Whatever the mind can conceive and believe, it can achieve. Success begins with a burning desire and definiteness of purpose.",
    insights: ["Thoughts are things with immense power", "A definite purpose backed by burning desire is unstoppable", "The mastermind principle multiplies your power", "Persistence is the key differentiator between success and failure"],
    actionItems: ["Write down your chief aim with a specific amount and deadline", "Form a mastermind group of 3-5 like-minded individuals", "Read your goals aloud twice daily - morning and night", "Develop a detailed plan and take the first step today"],
    coreTheme: "The starting point of all achievement is desire. Weak desire brings weak results."
  },
  {
    id: 6,
    title: "Rich Dad Poor Dad",
    author: "Robert Kiyosaki",
    category: "Wealth",
    categories: ["Wealth"],
    isbn: "9781612680194",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781612680194-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781612680194-L.jpg",
    summary: "The rich don't work for money - they make money work for them through assets and financial intelligence.",
    insights: ["The rich focus on their asset column while everyone else focuses on income", "It's not how much you make, it's how much you keep", "The single most powerful asset we all have is our mind", "Work to learn, not just to earn"],
    actionItems: ["Draw your current cash flow diagram", "Identify one expense you can convert into an income-generating asset", "Open a separate account for asset purchases only", "Read financial statements of 3 companies you admire"],
    coreTheme: "Learn the difference between assets and liabilities - acquire assets that generate cash flow."
  },
  {
    id: 7,
    title: "The Psychology of Money",
    author: "Morgan Housel",
    category: "Wealth",
    categories: ["Wealth", "Mindset"],
    isbn: "9780857197689",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9780857197689-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9780857197689-L.jpg",
    summary: "Financial success is not about how smart you are but about how you behave. Wealth is what you don't see.",
    insights: ["No one is crazy about money - everyone has unique experiences shaping their views", "Getting wealthy and staying wealthy require different skills", "Savings rate matters more than investment returns", "Room for error is the most important part of every plan"],
    actionItems: ["Calculate your current savings rate and aim to increase it by 5%", "Build a 6-month emergency fund before aggressive investing", "Define what 'enough' looks like for you", "Automate your investments to remove emotional decisions"],
    coreTheme: "Doing well with money isn't about what you know. It's about how you behave."
  },
  {
    id: 8,
    title: "The Richest Man in Babylon",
    author: "George Clason",
    category: "Wealth",
    categories: ["Wealth"],
    isbn: "9780451205360",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9780451205360-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9780451205360-L.jpg",
    summary: "Ancient Babylonian principles of wealth building through saving, investing wisely, and making money work for you.",
    insights: ["Pay yourself first - save at least 10% of everything you earn", "Make your gold multiply by investing it wisely", "Guard your treasures from loss", "Make of thy dwelling a profitable investment"],
    actionItems: ["Set up automatic transfer of 10% of income to savings", "Seek advice only from those competent in the matter", "Invest in what you understand", "Own your home rather than pay rent"],
    coreTheme: "A part of all you earn is yours to keep. Save it, invest it, and watch it grow."
  },
  {
    id: 9,
    title: "The Alchemist",
    author: "Paulo Coelho",
    category: "Purpose",
    categories: ["Purpose"],
    isbn: "9780062315007",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9780062315007-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9780062315007-L.jpg",
    summary: "When you want something, all the universe conspires in helping you achieve it. Follow your Personal Legend.",
    insights: ["The treasure you seek is often found where you began", "The fear of suffering is worse than suffering itself", "There is only one thing that makes a dream impossible: fear of failure", "When you are in love, things make even more sense"],
    actionItems: ["Identify your Personal Legend - what would you do if you couldn't fail?", "Take one step toward your dream this week", "Listen to the omens around you", "Trust that the universe rewards those who pursue their dreams"],
    coreTheme: "And, when you want something, all the universe conspires in helping you to achieve it."
  },
  {
    id: 10,
    title: "Ikigai",
    author: "Héctor García",
    category: "Purpose",
    categories: ["Purpose", "Vitality"],
    isbn: "9780143130727",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9780143130727-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9780143130727-L.jpg",
    summary: "The Japanese secret to a long and happy life lies at the intersection of what you love, what you're good at, what the world needs, and what you can be paid for.",
    insights: ["Having a clear purpose adds years to your life", "Stay active and don't retire - keep finding reasons to get up", "Surround yourself with good friends and stay connected", "Live in the moment and find flow in daily activities"],
    actionItems: ["Draw your Ikigai diagram and identify overlapping areas", "Reconnect with one activity you loved but stopped doing", "Add more vegetables and eat until 80% full (hara hachi bu)", "Find one activity that puts you in flow state daily"],
    coreTheme: "Your reason for being is found at the intersection of passion, mission, vocation, and profession."
  },
  {
    id: 11,
    title: "The Power of the Subconscious Mind",
    author: "Joseph Murphy",
    category: "Stillness",
    categories: ["Stillness", "Mindset"],
    isbn: "9780735204553",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/nlyjpx35_IMG_9422.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/nlyjpx35_IMG_9422.jpg",
    summary: "Your subconscious mind is a powerful force that can be harnessed through visualization, affirmation, and belief to achieve your goals.",
    insights: ["Whatever you impress upon your subconscious mind is expressed as reality", "Your habitual thinking patterns shape your destiny", "Before sleep, give your subconscious the problems you want solved", "Your thoughts are creative - choose them wisely"],
    actionItems: ["Write affirmations for your top 3 goals and repeat them before sleep", "Visualize your desired outcome in vivid detail for 5 minutes daily", "Replace negative self-talk with positive affirmations", "Practice gratitude to reprogram your subconscious"],
    coreTheme: "The treasure house is within you. Look within for the answer to your heart's desire."
  },
  {
    id: 12,
    title: "As a Man Thinketh",
    author: "James Allen",
    category: "Mindset",
    categories: ["Mindset"],
    isbn: "9780486452838",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9780486452838-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9780486452838-L.jpg",
    summary: "A man is literally what he thinks, his character being the complete sum of all his thoughts.",
    insights: ["Thought is the master key that shapes our destiny", "Circumstances do not make the man, they reveal him", "Good thoughts bear good fruit, bad thoughts bad fruit", "Dream lofty dreams, and as you dream, so shall you become"],
    actionItems: ["Monitor your thoughts for one day and note patterns", "Replace one recurring negative thought with its opposite", "Create a vision board of your ideal life", "Spend 10 minutes in silent contemplation each morning"],
    coreTheme: "As a man thinketh in his heart, so is he."
  },
  {
    id: 13,
    title: "Life's Amazing Secrets",
    author: "Gaur Gopal Das",
    category: "Purpose",
    categories: ["Purpose", "Mindset"],
    isbn: "9780143442295",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9780143442295-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9780143442295-L.jpg",
    summary: "A monk's guide to finding purpose, handling relationships, and achieving success through ancient wisdom applied to modern life.",
    insights: ["Life is like a wheel - happiness and distress come and go", "Forgiveness is the attribute of the strong", "Real love is wanting the best for someone", "Purpose comes from serving something bigger than yourself"],
    actionItems: ["Practice the 4-wheel balance: Personal, Relationships, Work, Social Contribution", "Forgive one person you've been holding a grudge against", "Spend quality time with loved ones without devices", "Find one way to serve your community this week"],
    coreTheme: "The quality of our life depends on the quality of our thoughts and relationships."
  },
  {
    id: 14,
    title: "Attitude is Everything",
    author: "Jeff Keller",
    category: "Mindset",
    categories: ["Mindset"],
    isbn: "9788188452842",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/es7zw9me_IMG_9421%202.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/es7zw9me_IMG_9421%202.jpg",
    summary: "Your attitude determines your altitude in life. Change your thoughts and you change your world.",
    insights: ["Your attitude is your window to the world", "You become what you think about most often", "Enthusiasm is contagious - and so is negativity", "Commitment means staying loyal to your decision even when feelings fade"],
    actionItems: ["Start each day with a positive affirmation", "Surround yourself with positive, successful people", "Read or listen to motivational content for 15 minutes daily", "Turn one complaint into an action plan"],
    coreTheme: "Your attitude, not your aptitude, will determine your altitude."
  },
  {
    id: 15,
    title: "Who Moved My Cheese?",
    author: "Dr. Spencer Johnson",
    category: "Mindset",
    categories: ["Mindset"],
    isbn: "9780399144462",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9780399144462-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9780399144462-L.jpg",
    summary: "A parable about embracing change and adapting quickly in work and life before it's too late.",
    insights: ["Change happens - anticipate it, monitor it, adapt to it quickly", "The quicker you let go of old cheese, the sooner you find new cheese", "Fear is holding you back, not the change itself", "Move with the cheese and enjoy it!"],
    actionItems: ["Identify one area of your life where you're resisting change", "Ask yourself: What would I do if I weren't afraid?", "Take one small step toward embracing a change you've been avoiding", "Imagine and visualize yourself succeeding in the new situation"],
    coreTheme: "What would you do if you weren't afraid?"
  },
  {
    id: 16,
    title: "Eat That Frog!",
    author: "Brian Tracy",
    category: "Habits",
    categories: ["Habits", "Deep Focus", "Vitality"],
    isbn: "9781576754221",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/qjsm0b1c_IMG_9401%203.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/qjsm0b1c_IMG_9401%203.jpg",
    summary: "If you have to eat a live frog, do it first thing in the morning. Tackle your biggest, most important task first.",
    insights: ["Your 'frog' is your biggest, most important task", "If you have two frogs, eat the uglier one first", "Discipline yourself to begin immediately and persist until complete", "Planning your day the night before supercharges your subconscious"],
    actionItems: ["Identify your 'frog' for tomorrow and write it down tonight", "Do your most important task first thing in the morning", "Apply the 80/20 rule - focus on the 20% that produces 80% of results", "Say no to activities that don't contribute to your goals"],
    coreTheme: "The ability to concentrate on your most important task and complete it is the key to success."
  },
  {
    id: 17,
    title: "The 80/20 Principle",
    author: "Richard Koch",
    category: "Deep Focus",
    categories: ["Deep Focus", "Strategy"],
    isbn: "9780385491747",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/qm1f0ao4_IMG_9420.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/qm1f0ao4_IMG_9420.jpg",
    summary: "80% of results come from 20% of efforts. Find and focus on the vital few activities that produce the most impact.",
    insights: ["Most of what you do doesn't matter - find the 20% that does", "The majority of problems come from a minority of causes", "Happiness comes from selective attention, not total effort", "Less is more when you focus on what really works"],
    actionItems: ["List your top 10 activities and identify which 2 create 80% of your results", "Eliminate or delegate the bottom 80% of low-value activities", "Double down on your most productive relationships", "Apply 80/20 thinking to how you spend your time daily"],
    coreTheme: "Focus on the vital few and ignore the trivial many."
  },
  {
    id: 18,
    title: "Deep Work",
    author: "Cal Newport",
    category: "Deep Focus",
    categories: ["Deep Focus"],
    isbn: "9781455586691",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781455586691-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781455586691-L.jpg",
    summary: "The ability to perform deep, focused work is becoming increasingly rare and increasingly valuable in our distracted world.",
    insights: ["Deep work is the superpower of the 21st century", "Shallow work is seductive but ultimately unfulfilling", "Schedule every minute of your day", "Embrace boredom - constant stimulation kills deep work ability"],
    actionItems: ["Block 2-4 hours daily for deep work with no interruptions", "Quit social media for 30 days and see what you miss", "Create a shutdown ritual to end your workday", "Embrace boredom - don't reach for your phone immediately"],
    coreTheme: "To produce at your peak level you need to work for extended periods with full concentration."
  },
  {
    id: 19,
    title: "The Miracle Morning",
    author: "Hal Elrod",
    category: "Habits",
    categories: ["Habits", "Vitality"],
    isbn: "9780979019715",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9780979019715-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9780979019715-L.jpg",
    summary: "Transform your life by waking up early and practicing the SAVERS: Silence, Affirmations, Visualization, Exercise, Reading, Scribing.",
    insights: ["How you start your day determines how you live your life", "Your level of success rarely exceeds your level of personal development", "The moment you accept responsibility, you gain power to change", "Consistency beats intensity"],
    actionItems: ["Set your alarm 60 minutes earlier tomorrow", "Create your personalized SAVERS routine", "Put your alarm across the room", "Join an accountability group or find an accountability partner"],
    coreTheme: "Your level of success will rarely exceed your level of personal development."
  },
  {
    id: 20,
    title: "The 5 AM Club",
    author: "Robin Sharma",
    category: "Vitality",
    categories: ["Vitality", "Habits"],
    isbn: "9781443456623",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781443456623-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781443456623-L.jpg",
    summary: "Own your morning, elevate your life. The Victory Hour at 5 AM is where legends are made through the 20/20/20 Formula.",
    insights: ["All great geniuses were skilled at daily self-optimization", "Small daily improvements lead to stunning results", "Your excuses are seducers, your fears are liars", "Genius is less about genetics and more about habits"],
    actionItems: ["Wake up at 5 AM for 66 days to build the habit", "Use the 20/20/20 Formula: Move, Reflect, Grow", "Go to bed by 9 PM to ensure proper rest", "Protect your morning from technology and distractions"],
    coreTheme: "All change is hard at first, messy in the middle, and gorgeous at the end."
  },
  {
    id: 21,
    title: "The Almanack of Naval Ravikant",
    author: "Eric Jorgenson",
    category: "Strategy",
    categories: ["Strategy", "Wealth"],
    isbn: "9781544514215",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781544514215-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781544514215-L.jpg",
    summary: "Build wealth and happiness through specific knowledge, accountability, leverage, and long-term thinking.",
    insights: ["Play long-term games with long-term people", "Arm yourself with specific knowledge, accountability, and leverage", "Read what you love until you love to read", "Happiness is a choice and a skill you can develop"],
    actionItems: ["Identify your unique combination of skills and knowledge", "Start building leverage: create content, write code, or build systems", "Take accountability for outcomes in one area of your life", "List 10 things you're genuinely curious about and explore one"],
    coreTheme: "Get rich by giving society what it wants but doesn't know how to get - at scale."
  },
  {
    id: 22,
    title: "Build, Don't Talk",
    author: "Raj Shamani",
    category: "Leadership",
    categories: ["Leadership", "Strategy", "Wealth"],
    isbn: "9789391165970",
    coverUrl: "https://customer-assets.emergentagent.com/job_wisdom-in-practice/artifacts/thlwn0h4_image.png",
    image: "https://customer-assets.emergentagent.com/job_wisdom-in-practice/artifacts/thlwn0h4_image.png",
    summary: "Stop planning, stop talking about your dreams - start building them today. Action beats intention every time.",
    insights: ["Everyone has ideas, but only builders create impact", "The best time to start was yesterday, the second best is now", "Your personal brand is built through action", "Document your journey, don't create fake personas"],
    actionItems: ["Start building your idea today - launch an MVP in 30 days", "Replace 1 hour of social media with building", "Document your journey on LinkedIn/Twitter authentically", "Reach out to 5 builders in your field"],
    coreTheme: "Success comes from consistent building, not endless talking about what you'll do someday."
  },
  {
    id: 23,
    title: "Ask and It Is Given",
    author: "Esther & Jerry Hicks",
    category: "Stillness",
    categories: ["Stillness"],
    isbn: "9781401904593",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781401904593-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781401904593-L.jpg",
    summary: "The Law of Attraction responds to your vibration. Ask, believe, and receive through alignment with your desires.",
    insights: ["You get what you think about, whether you want it or not", "Your emotions are your guidance system", "The universe responds to your vibration, not your words", "Appreciation is the highest form of vibration"],
    actionItems: ["Practice the Rampage of Appreciation for 5 minutes daily", "Reach for better-feeling thoughts when you feel negative", "Create a vision board of your desires", "Monitor your emotions as guidance throughout the day"],
    coreTheme: "You are the creator of your own reality through the thoughts you think and feel."
  },
  {
    id: 24,
    title: "The Silva Method",
    author: "José Silva",
    category: "Stillness",
    categories: ["Stillness"],
    isbn: "9780671739898",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9780671739898-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9780671739898-L.jpg",
    summary: "Use the power of your mind at alpha level to program yourself for success, healing, and enhanced mental abilities.",
    insights: ["The alpha level is the ideal state for programming your mind", "You can control your brainwave states with practice", "Visualization at alpha level accelerates goal achievement", "Your mind can influence your physical health"],
    actionItems: ["Practice the 3-2-1 countdown technique to reach alpha level", "Visualize your goals while in alpha state daily", "Use the mental screen technique for problem-solving", "Program yourself before sleep for better rest"],
    coreTheme: "You have the power to use more of your mind and tap into your full potential."
  },
  {
    id: 25,
    title: "Creative Visualization",
    author: "Shakti Gawain",
    category: "Stillness",
    categories: ["Stillness"],
    isbn: "9781577312024",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/r20l5j63_IMG_9407.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/r20l5j63_IMG_9407.jpg",
    summary: "Use the power of imagination to create what you want in your life through focused visualization and affirmation.",
    insights: ["Imagination is the ability to create ideas or mental images", "Energy follows thought", "The more you use creative visualization, the easier it becomes", "Your beliefs create your reality"],
    actionItems: ["Create a clear mental image of what you want to manifest", "Practice visualizing in a relaxed, receptive state", "Write affirmations that support your visualizations", "Trust the process and let go of attachment to outcomes"],
    coreTheme: "Creative visualization is the technique of using your imagination to create what you want in life."
  },
  {
    id: 26,
    title: "Mindset",
    author: "Carol Dweck",
    category: "Mindset",
    categories: ["Mindset"],
    isbn: "9780345472328",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/zce4q0yu_IMG_9399.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/zce4q0yu_IMG_9399.jpg",
    summary: "The growth mindset - believing abilities can be developed - is the foundation of achievement and success.",
    insights: ["In a growth mindset, challenges are opportunities to grow", "Effort is the path to mastery", "Failure is not evidence of unintelligence but a starting point", "Praise the process, not the outcome"],
    actionItems: ["Catch yourself in fixed mindset thinking and reframe it", "Add 'yet' to statements: 'I can't do this...yet'", "Embrace challenges rather than avoiding them", "Learn from criticism instead of ignoring it"],
    coreTheme: "The view you adopt for yourself profoundly affects the way you lead your life."
  },
  {
    id: 27,
    title: "The 7 Habits of Highly Effective People",
    author: "Stephen Covey",
    category: "Leadership",
    categories: ["Leadership", "Habits"],
    isbn: "9781451639612",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781451639612-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781451639612-L.jpg",
    summary: "True effectiveness comes from principles, not techniques. Move from dependence to independence to interdependence.",
    insights: ["Be proactive - you choose your response to any situation", "Begin with the end in mind - define your life's purpose", "Put first things first - prioritize based on importance, not urgency", "Think win-win in all relationships"],
    actionItems: ["Write a personal mission statement", "Identify your roles and set goals for each", "Schedule weekly planning time", "Practice empathic listening in your next conversation"],
    coreTheme: "Sow a thought, reap an action; sow an action, reap a habit; sow a habit, reap a character."
  },
  {
    id: 28,
    title: "How to Win Friends and Influence People",
    author: "Dale Carnegie",
    category: "Leadership",
    categories: ["Leadership"],
    isbn: "9780671027032",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/yffau8v7_IMG_9417.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/yffau8v7_IMG_9417.jpg",
    summary: "The art of dealing with people through genuine interest, appreciation, and understanding their perspective.",
    insights: ["Become genuinely interested in other people", "Remember that a person's name is the sweetest sound", "Be a good listener and encourage others to talk about themselves", "Make the other person feel important - sincerely"],
    actionItems: ["Remember and use people's names in conversation", "Ask questions about their interests rather than talking about yours", "Give honest, sincere appreciation today", "Admit when you're wrong quickly and emphatically"],
    coreTheme: "You can make more friends in two months by being interested than in two years by being interesting."
  },
  {
    id: 29,
    title: "The Power of Now",
    author: "Eckhart Tolle",
    category: "Stillness",
    categories: ["Stillness"],
    isbn: "9781577314806",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781577314806-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781577314806-L.jpg",
    summary: "Enlightenment means rising above thought. Only the present moment is real - past and future are illusions of the mind.",
    insights: ["You are not your thoughts - you are the awareness behind them", "The present moment is all you ever have", "Pain is created by resistance to what is", "Most suffering comes from psychological time - past and future"],
    actionItems: ["Practice being fully present during mundane activities", "Notice when you're lost in thought and return to now", "Accept this moment exactly as it is", "Feel the inner body as an anchor to presence"],
    coreTheme: "Realize deeply that the present moment is all you have. Make the Now the primary focus of your life."
  },
  {
    id: 30,
    title: "Start with Why",
    author: "Simon Sinek",
    category: "Leadership",
    categories: ["Leadership", "Strategy"],
    isbn: "9781591846444",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781591846444-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781591846444-L.jpg",
    summary: "People don't buy what you do, they buy why you do it. Great leaders inspire action by starting with why.",
    insights: ["The Golden Circle: Why → How → What", "People connect with purpose, not features", "Those who start with why inspire loyalty and trust", "Your why is your cause, your belief, your reason for existing"],
    actionItems: ["Define your personal WHY in one sentence", "Communicate your why before explaining what you do", "Hire and partner with those who believe what you believe", "Make decisions based on your why, not short-term gains"],
    coreTheme: "People don't buy what you do; they buy why you do it."
  },
  {
    id: 31,
    title: "The Compound Effect",
    author: "Darren Hardy",
    category: "Habits",
    categories: ["Habits", "Mindset", "Wealth"],
    isbn: "9781593157241",
    coverUrl: "https://books.google.com/books/content?id=P28DsLkv5cgC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    image: "https://books.google.com/books/content?id=P28DsLkv5cgC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    summary: "Small, smart choices + consistency + time = radical difference. Success is earned through compound actions.",
    insights: ["Small choices compound into massive results over time", "You reap what you sow - no more, no less", "Track your behaviors to become aware of patterns", "Momentum is the Big Mo - once started, hard to stop"],
    actionItems: ["Track one key behavior for 30 days", "Make one small positive change and stick to it", "Review your progress weekly", "Build positive momentum with small wins"],
    coreTheme: "It's not the big things that add up; it's the hundreds and thousands of little things."
  },
  {
    id: 32,
    title: "The Courage to Be Happy",
    author: "Ichiro Kishimi",
    category: "Stillness",
    categories: ["Mindset"],
    isbn: "9781501163227",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/zodbn3t8_IMG_9404%202.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/zodbn3t8_IMG_9404%202.jpg",
    summary: "True happiness comes from the courage to be disliked and live authentically according to your own values.",
    insights: ["Happiness is a choice, not a result", "The courage to be disliked is the courage to be free", "All problems are interpersonal relationship problems", "You can change right now if you choose"],
    actionItems: ["Identify one area where you seek others' approval too much", "Practice making decisions based on your values, not others' expectations", "Accept that not everyone will like you - and that's okay", "Focus on contribution rather than recognition"],
    coreTheme: "The courage to be happy is the courage to be yourself without seeking others' approval."
  },
  {
    id: 33,
    title: "Make Your Bed",
    author: "Admiral William McRaven",
    category: "Purpose",
    categories: ["Purpose", "Habits", "Vitality"],
    isbn: "9781455570249",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781455570249-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781455570249-L.jpg",
    summary: "Small tasks, done correctly and consistently, compound into life-changing habits. Start with making your bed.",
    insights: ["Making your bed gives you a small sense of pride", "Small tasks done well lead to bigger accomplishments", "Life is not fair - move forward anyway", "Hope is powerful - never give up"],
    actionItems: ["Make your bed immediately after waking up", "Complete small tasks with excellence", "Face your fears by taking the first step", "Encourage someone struggling today"],
    coreTheme: "If you want to change the world, start by making your bed."
  },
  {
    id: 34,
    title: "The Artist's Way",
    author: "Julia Cameron",
    category: "Habits",
    categories: ["Habits", "Purpose"],
    isbn: "9781585421466",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/u3t7l13k_IMG_9305.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/u3t7l13k_IMG_9305.jpg",
    summary: "A transformative 12-week program to recover and discover your creative self. Julia Cameron's groundbreaking approach combines spirituality with practical exercises to unblock creativity and overcome self-doubt.",
    insights: ["Everyone is creative - creativity is a spiritual practice, not just a talent", "Morning Pages (3 pages of stream-of-consciousness writing) clear mental clutter", "Artist Dates (solo weekly outings) nurture your inner artist and refill the creative well", "Creative blocks are often rooted in fear, shame, and internalized criticism from the past"],
    actionItems: ["Start writing Morning Pages every day - 3 handwritten pages before anything else", "Schedule a weekly Artist Date - a solo adventure to inspire and play", "Identify and challenge your inner critic by naming negative beliefs about creativity", "Complete one creative task you've been putting off this week"],
    coreTheme: "Creativity is your birthright - recovering it is a spiritual journey of self-discovery and courage."
  },
  {
    id: 35,
    title: "Wise and Otherwise",
    author: "Sudha Murty",
    category: "Purpose",
    categories: ["Purpose"],
    isbn: "9780143062103",
    coverUrl: "https://covers.openlibrary.org/b/id/10795720-L.jpg",
    image: "https://covers.openlibrary.org/b/id/10795720-L.jpg",
    summary: "A collection of 51 true stories that capture the essence of human nature across India. Sudha Murty shares encounters with ordinary people that reveal extraordinary wisdom, compassion, and life lessons.",
    insights: ["True wisdom often comes from the most unexpected people and places", "Simplicity and humility are the hallmarks of genuinely wise individuals", "Every person you meet has something valuable to teach you", "Material wealth means nothing without kindness and integrity"],
    actionItems: ["Listen more than you speak - everyone has a story worth hearing", "Practice random acts of kindness without expecting anything in return", "Spend time with people from different walks of life to broaden your perspective", "Reflect on one life lesson you learned from an unexpected source this week"],
    coreTheme: "Wisdom is not found in books alone - it lives in the hearts of ordinary people doing extraordinary things."
  },
  {
    id: 36,
    title: "Think Again",
    author: "Adam Grant",
    category: "Strategy",
    categories: ["Strategy", "Mindset"],
    isbn: "9781984878106",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781984878106-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781984878106-L.jpg",
    summary: "The power of knowing what you don't know — rethinking and unlearning are more valuable than raw intelligence.",
    insights: ["Confident humility outperforms arrogance and self-doubt", "Treat your beliefs like hypotheses, not identity", "Disagree without being disagreeable — argue like you're right, listen like you're wrong", "The smartest people regularly change their minds in light of new evidence"],
    actionItems: ["Once a week, write down a belief you used to hold and how it changed", "Invite a thoughtful disagreement before any major decision", "Replace \"I know\" with \"I think\" in three sentences this week", "Ask one curious question for every opinion you give today"],
    coreTheme: "In a fast-changing world, the ability to rethink and unlearn is the highest form of intelligence."
  },
  {
    id: 37,
    title: "But What Does Science Say?",
    author: "Dr. Manan Vohra",
    category: "Vitality",
    categories: ["Vitality"],
    isbn: "9789356997622",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/5m2lh9m0_IMG_9419.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/5m2lh9m0_IMG_9419.jpg",
    summary: "A practical, evidence-based guide separating wellness myths from what actually works for everyday Indians.",
    insights: ["Most \"wellness wisdom\" online is anecdotal — demand the evidence", "Sleep, sunlight, movement and food beat any supplement", "Small daily routines compound faster than dramatic transformations", "Your habits speak louder than your willpower"],
    actionItems: ["Audit one health habit you follow — is it backed by data?", "Replace one screen-scrolling hour with sunlight + a walk this week", "Track sleep duration for 7 nights and note your mood scores", "Pick one supplement you take and ask: where's the evidence?"],
    coreTheme: "Wellness is built on science, not slogans — daily basics outperform every shortcut."
  },
  {
    id: 38,
    title: "The Leader Who Had No Title",
    author: "Robin Sharma",
    category: "Leadership",
    categories: ["Leadership"],
    isbn: "9781439109137",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/61no219i_IMG_9402%202.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/61no219i_IMG_9402%202.jpg",
    summary: "You don't need a title or position to lead — you can show leadership in any role, every day.",
    insights: ["Leadership is a way of being, not a job title", "Innovation is the language of every great leader", "Tiny daily acts of mastery compound into massive influence", "The way you do small things is the way you do everything"],
    actionItems: ["Pick one task today and do it 10x better than expected", "Help someone at work without being asked — and don't mention it", "Replace one complaint with one constructive idea this week", "Write down 3 leadership traits you want to be known for"],
    coreTheme: "Lead from where you stand — title or no title, your impact is your choice."
  },
  {
    id: 39,
    title: "Who Will Cry When You Die?",
    author: "Robin Sharma",
    category: "Purpose",
    categories: ["Purpose"],
    isbn: "9780786887606",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/s0hwxul2_IMG_9400%203.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/s0hwxul2_IMG_9400%203.jpg",
    summary: "101 short, practical lessons on living a richer, kinder, more deliberate life.",
    insights: ["Live so that those you love will miss you when you're gone", "Small daily kindnesses are what people remember", "Time is the most valuable currency — invest it deliberately", "Your legacy is shaped one small choice at a time"],
    actionItems: ["Write a thank-you note to someone who shaped you — today", "Identify one daily ritual that brings you peace and protect it", "Cut one activity that doesn't deserve your time", "Ask: if I died next year, what would I regret not doing?"],
    coreTheme: "A meaningful life is built from small, daily acts of love, courage and presence."
  },
  {
    id: 40,
    title: "Talk Like TED",
    author: "Carmine Gallo",
    category: "Leadership",
    categories: ["Leadership"],
    isbn: "9781250061539",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781250061539-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781250061539-L.jpg",
    summary: "The 9 public-speaking secrets used by the world's top TED presenters to inform, inspire and ignite.",
    insights: ["Passion is contagious — speak about what genuinely moves you", "Tell stories — the brain remembers narrative, not bullet points", "Less is more: master the 18-minute rule", "Wow your audience with novelty — surprise wakes up the brain"],
    actionItems: ["Open your next presentation with a personal story, not a slide", "Cut your slide deck in half — keep only what supports a single idea", "Practice your next talk standing, out loud, three times", "Record yourself once and watch it back — fix one habit"],
    coreTheme: "Great talks combine emotion, novelty and story to make ideas unforgettable."
  },
  {
    id: 41,
    title: "Blue Ocean Strategy",
    author: "W. Chan Kim & Renée Mauborgne",
    category: "Strategy",
    categories: ["Strategy", "Leadership"],
    isbn: "9781591396192",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781591396192-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781591396192-L.jpg",
    summary: "Stop competing in bloody red oceans — create new uncontested market space where the competition is irrelevant.",
    insights: ["Don't fight for a bigger slice — make a bigger pie", "Value innovation = differentiation + low cost, simultaneously", "Look across industries, buyers and complements to find blue space", "The customers who matter most are the ones you don't serve yet"],
    actionItems: ["List your top 3 competitors and ask: what could I make irrelevant?", "Map the strategy canvas of your industry on one page", "Identify one factor every player has — and consider eliminating it", "Talk to 5 non-customers and ask why they're not buying"],
    coreTheme: "The best strategy is to make competition irrelevant — by creating new market space."
  },
  {
    id: 42,
    title: "Dopamine Detox",
    author: "Thibaut Meurisse",
    category: "Habits",
    categories: ["Habits"],
    isbn: "9798522028565",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/ekiq05sx_IMG_9396.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/ekiq05sx_IMG_9396.jpg",
    summary: "Reset your brain's reward system by stepping back from artificial stimulation — and rediscover real focus.",
    insights: ["Endless dopamine hits dull your motivation for meaningful work", "Boredom is the cradle of creativity — not a problem to be solved", "Small daily detoxes outperform dramatic willpower marathons", "Your environment, not your discipline, decides your distractions"],
    actionItems: ["Schedule one 24-hour low-stimulation day this week", "Delete the apps you reach for in idle moments", "Replace one scrolling habit with a 10-minute walk", "Sit silently for 5 minutes, twice a day — no phone, no music"],
    coreTheme: "Reset your reward system to reclaim attention, motivation and depth of work."
  },
  {
    id: 43,
    title: "What Got You Here Won't Get You There",
    author: "Marshall Goldsmith",
    category: "Leadership",
    categories: ["Leadership"],
    isbn: "9781401301309",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781401301309-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781401301309-L.jpg",
    summary: "The behaviours that made you successful at one level often become the very habits that block your next level.",
    insights: ["You can't out-perform your blind spots — get feedback and act on it", "Smart, successful people are the hardest to coach — and the most in need of it", "Stop adding value at the expense of others — they'll resent it", "Apology is a leadership skill, not a weakness"],
    actionItems: ["Ask 5 colleagues: \"What's one thing I should stop doing?\"", "Identify one habit that worked at level N — and is blocking level N+1", "Apologise to one person you've been undermining without realising", "Replace \"but\" with \"and\" in your next 10 conversations"],
    coreTheme: "The path to your next level is paved with what you must stop, not what you must add."
  },
  {
    id: 44,
    title: "Made to Stick",
    author: "Chip Heath & Dan Heath",
    category: "Strategy",
    categories: ["Strategy", "Leadership"],
    isbn: "9781400064281",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9781400064281-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9781400064281-L.jpg",
    summary: "Why some ideas survive and others die — and the six principles that make ideas memorable.",
    insights: ["Simple, Unexpected, Concrete, Credible, Emotional, Story (SUCCES)", "Strip your idea to a single core message — bury what isn't essential", "Stories beat statistics in every memory test ever run", "Concreteness beats abstraction — show, don't generalise"],
    actionItems: ["Take your next big idea — express it in one short sentence", "Replace one stat in your pitch with a single, specific story", "Add one unexpected, surprising detail to your message", "Ask: would a 12-year-old understand this? If not, simplify"],
    coreTheme: "Sticky ideas are simple, unexpected, concrete, credible, emotional and stitched into story."
  },
  {
    id: 45,
    title: "Don't Believe Everything You Think",
    author: "Joseph Nguyen",
    category: "Mindset",
    categories: ["Mindset"],
    isbn: "9798987770504",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/6b94z8b3_IMG_9397.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/6b94z8b3_IMG_9397.jpg",
    summary: "Most of your suffering comes not from life — but from the thoughts you mistake for reality.",
    insights: ["You are not your thoughts — you are the awareness behind them", "Suffering grows from believing your every thought is true", "Peace is your natural state when thinking pauses", "Inspired action arises from stillness, not from anxious doing"],
    actionItems: ["When stressed today, ask: \"Which thought am I believing right now?\"", "Schedule three 2-minute \"no thinking\" pauses today", "Notice one strong feeling and trace it back to the thought beneath it", "Replace one anxious self-narrative with: \"This may not be true.\""],
    coreTheme: "You don't need to fix your circumstances — only stop believing the thoughts that distort them."
  },
  {
    id: 46,
    title: "I am not a Doctor",
    author: "Peter Theobald",
    category: "Vitality",
    categories: ["Vitality"],
    isbn: "9789354898501",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/ccr74eon_IMG_9398.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/ccr74eon_IMG_9398.jpg",
    summary: "A self-experimenter's practical guide to taking charge of your own body — without medicalising every problem.",
    insights: ["Your body is more resilient and self-healing than the system tells you", "Most modern ailments are lifestyle, not pathology — fix the root", "You are the only one who lives in your body 24/7 — own that authority", "Ask \"why\" five times before reaching for a pill"],
    actionItems: ["List the medications you take and ask: which root cause am I bypassing?", "Pick one lifestyle lever (sleep, food, sun, movement) and improve it for 30 days", "Track your symptoms in a notebook for one week", "Get one second opinion before any non-urgent intervention"],
    coreTheme: "You are the chief authority on your own body — listen to it, learn from it, lead it."
  },
  {
    id: 47,
    title: "The Courage to Be Disliked",
    author: "Ichiro Kishimi & Fumitake Koga",
    category: "Mindset",
    categories: ["Mindset", "Purpose"],
    isbn: "9781501197277",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/n8t9s1of_IMG_9403%202.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/n8t9s1of_IMG_9403%202.jpg",
    summary: "A dialogue-driven journey through Adlerian psychology — free yourself from the expectations of others and choose the courage to simply be you.",
    insights: ["All problems are interpersonal — the way you see relationships shapes your suffering", "You cannot live without being disliked by someone; trying to please everyone is the trap", "Separate your tasks from other people's tasks — own only what is yours to own", "Happiness is the feeling of contribution — not the accumulation of approval"],
    actionItems: ["Identify one person whose approval you're chasing — and let it go", "Before a difficult conversation, ask: \"Whose task is this, really?\"", "Replace \"I have to...\" with \"I choose to...\" in three sentences today", "Write down one thing you'll do today just because it matters to you"],
    coreTheme: "Real freedom begins the moment you find the courage to be disliked."
  },
  {
    id: 48,
    title: "Manifest",
    author: "Roxie Nafousi",
    category: "Stillness",
    categories: ["Purpose"],
    isbn: "9780241586266",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/m8nilaav_IMG_9406%202.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/m8nilaav_IMG_9406%202.jpg",
    summary: "A grounded, 7-step guide to manifesting the life you want — not by wishing, but by aligning belief, action and self-worth.",
    insights: ["Manifestation is not magical thinking — it's clarity of vision plus consistent action", "Your self-worth is the ceiling on everything you allow into your life", "Turn envy into inspiration — it points at what you truly want", "Trust the timing and let go of the \"how\" — focus only on the next right step"],
    actionItems: ["Write your vision for the next year in vivid, present-tense detail", "Identify one limiting belief — and rewrite it as an empowering one", "Replace one moment of envy today with a specific lesson", "Take one small action tomorrow that aligns with your vision"],
    coreTheme: "You manifest what you believe you deserve — raise the ceiling of your self-worth."
  },
  {
    id: 49,
    title: "The Hidden Messages in Water",
    author: "Masaru Emoto",
    category: "Stillness",
    categories: ["Stillness"],
    isbn: "9780743289801",
    coverUrl: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/mf5v8k8u_IMG_9405%202.jpg",
    image: "https://customer-assets.emergentagent.com/job_84966c81-80ea-4d88-ba8f-6408937076dd/artifacts/mf5v8k8u_IMG_9405%202.jpg",
    summary: "Emoto's striking photographs and research suggest that water responds to human thought, word and intention — inviting us to live with more conscious energy.",
    insights: ["Words and intentions carry measurable energy — they ripple into the world around us", "Our bodies are 70% water — the quality of our thoughts shapes the state we live in", "Gratitude, love and kindness form beautiful patterns; fear and anger disrupt them", "Awareness of the energy we give out is the first step to the energy we receive"],
    actionItems: ["Write three words of gratitude on a glass of water each morning — then drink it mindfully", "Catch one negative thought today and replace it with a kinder one", "Speak to yourself the way you would to someone you love", "Spend five minutes in silence near water — listen, don't think"],
    coreTheme: "The energy you carry shapes the world you move through — choose your thoughts as you'd choose your words."
  },
  {
    id: 50,
    title: "Man's Search for Meaning",
    author: "Viktor E. Frankl",
    category: "Stillness",
    categories: ["Stillness", "Mindset"],
    isbn: "9780807014295",
    coverUrl: "https://covers.openlibrary.org/b/isbn/9780807014295-L.jpg",
    image: "https://covers.openlibrary.org/b/isbn/9780807014295-L.jpg",
    summary: "A psychiatrist's account of surviving the Holocaust and the school of logotherapy he founded — the deepest human drive is not pleasure, but meaning.",
    insights: ["Between stimulus and response there is a space — in that space is our power to choose", "Meaning, not happiness, is the truest human pursuit", "Even suffering, when meaningful, becomes bearable", "Those who have a 'why' to live can bear almost any 'how'"],
    actionItems: ["Tonight, write one moment from today that felt meaningful — even a single sentence", "Identify your 'why' for the next 90 days and pin it where you see it daily", "When emotion rises, pause for one breath before responding — guard the space", "Once this week, do something purely in service of someone else"],
    coreTheme: "Meaning is not given. It is found — in work done, love given, and suffering transmuted."
  }
];

export const coreAreas = [
  {
    id: 1,
    name: "Habits",
    icon: "Leaf",
    color: "forest",
    ribbon: "#4F6B3D",
    description: "Small daily moves.\nBig life shifts.\nBuild rituals that quietly change everything.",
    image: "/category-art/habits_clean.png",
    artCaption: "Of Quiet Mornings",
    featured: true
  },
  {
    id: 2,
    name: "Deep Focus",
    icon: "Compass",
    color: "navy",
    ribbon: "#2A3F66",
    description: "Distraction-free work\nin a world of noise.\nFor readers who want to ship their best thinking.",
    image: "/category-art/deep_focus_clean.png",
    artCaption: "The Lamplit Hour",
    featured: true
  },
  {
    id: 3,
    name: "Wealth",
    icon: "Coins",
    color: "bronze",
    ribbon: "#7B5530",
    description: "Build money with clarity,\nnot hustle culture.\nFor readers who want money to work for them.",
    image: "/category-art/wealth_clean.png",
    artCaption: "Ledgers & Coin",
    featured: true
  },
  {
    id: 4,
    name: "Purpose",
    icon: "Compass",
    color: "teal",
    ribbon: "#3F7A78",
    description: "Meaning is found,\nnot given.\nFor readers searching for the reason they got up today.",
    image: "/category-art/purpose_clean.png",
    artCaption: "The Wandering Path",
    featured: true
  },
  {
    id: 5,
    name: "Strategy",
    icon: "Crown",
    color: "purple",
    ribbon: "#5C4670",
    description: "Sharper thinking.\nSmarter bets.\nFor readers who see three moves ahead.",
    image: "/category-art/strategy_clean.png",
    artCaption: "Three Moves Ahead"
  },
  {
    id: 6,
    name: "Mindset",
    icon: "BookOpen",
    color: "gold",
    ribbon: "#B08842",
    description: "Change how you think.\nChange what you see.\nFor readers ready to unlearn their oldest stories.",
    image: "/category-art/mindset_clean.png",
    artCaption: "Marginalia",
    featured: true
  },
  {
    id: 7,
    name: "Vitality",
    icon: "Activity",
    color: "moss",
    ribbon: "#5A7549",
    description: "Energy is a choice.\nBuild strength, clarity\nand resilience that lasts.",
    image: "/category-art/vitality_clean.png",
    artCaption: "First Light"
  },
  {
    id: 8,
    name: "Stillness",
    icon: "Moon",
    color: "burgundy",
    ribbon: "#6B2C2A",
    description: "Slow down to hear what matters.\nFor readers seeking peace\nin a restless world.",
    image: "/category-art/stillness_clean.png",
    artCaption: "Candle & Tea"
  },
  {
    id: 9,
    name: "Leadership",
    icon: "Landmark",
    color: "slate",
    ribbon: "#4A5C7A",
    description: "Lead yourself first.\nInspire others always.\nBuild influence that outlives you.",
    image: "/category-art/leadership_clean.png",
    artCaption: "Pillars of the Old Library"
  }
];
